























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { EnquiryProduct } from '@/models/enquiry-product';
import { Enquiry } from '@/models/enquiry';
import { namespace, Getter } from 'vuex-class';
import { Getters } from '@/stores/enquiries/getter-constants';
import { Mutations } from '@/stores/enquiries/mutation-constants';
import loading from '@/components/loading.vue';
import { DateTime } from 'luxon';
import enquiryStatusLabel from '@/components/enquiry-status-label.vue';
import { dateParse } from '@/date-picker-parser';
import { Permissions } from '@/models/permission-constants';
import debounce from 'lodash.debounce';

const EnquiryModule = namespace('enquiry');
const UserModule = namespace('user');

@Component({
    components: {
        loading,
        enquiryStatusLabel,
    },
})
export default class EnquiryList extends Vue {
    @Prop({ required: true }) public enquiries: Array<Enquiry>;
    @Prop({ type: Number, default: 1 }) public totalPages: number;
    @Prop({ type: Number, default: 1 }) public page: number;
    @Prop({ type: Number, default: 1 }) public pageSize: number;
    @Prop({ type: Number, default: 1 }) public total: number;
    @Prop({ type: String }) public keyword: string | null;
    @Prop({ type: [Number, String] }) public status: number | string;
    @Prop({ type: Boolean, default: false }) public isLoading: boolean;
    @Prop({ type: Boolean, default: false }) public showCreator: boolean;
    @Prop({ type: Boolean, default: false }) public showActions: boolean;
    @Prop({ type: String }) public from: string | null;
    @Prop({ type: String }) public to: string | null;
    @UserModule.Getter public canViewQuotes: boolean;
    @UserModule.Getter public canViewEnquiries: boolean;
    @UserModule.Getter public canCreateQuotes: boolean;
    @UserModule.Getter public user: boolean;
    public currentKeyword: string | null = this.keyword;
    public currentStatus: number | string | null = this.status;
    public currentPage: number = this.page;
    public currentPageSize = this.pageSize;
    public currentFrom: string | null = (this.from ? DateTime.fromFormat(this.from, 'yyyy-MM-dd').toLocaleString() : this.from) || null;
    public currentTo: string | null = (this.to ? DateTime.fromFormat(this.to, 'yyyy-MM-dd').toLocaleString() : this.to) || null;
    public parseDate = dateParse;

    public get paginationDescription(): string {
        const start = (this.enquiries.length < 1)
            ? 0
            : ((this.currentPage - 1) * this.pageSize) + 1;

        const end = start + this.pageSize > this.total
            ? this.total
            : start + this.pageSize;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.total.toLocaleString()}`;
    }

    @Watch('currentKeyword')
    public currentKeywordChanged(value: string | null): void {
        this.$emit('keyword-changed', value);
        this.currentPage = this.page;
    }
    @Watch('currentStatus')
    public currentStatusChanged(value: string | null): void {
        this.$emit('status-changed', value);
        this.currentPage = this.page;
    }
    @Watch('currentPageSize')
    public currentPageSizeChanged(value: number, old: number): void {
        if (value === old) {
            return;
        }

        this.$emit('page-size-changed', value);
    }
    @Watch('currentPage')
    public currentPageChanged(value: number, old: number): void {
        if (value === old) {
            return;
        }

        this.$emit('page-changed', value);
    }
    @Watch('currentFrom')
    public currentFromDateChanged(value: string): void {
        // NOTE(Dan): The date for the control is formatted in dd/MM/yyyy,
        //            this needs to be converted to an ISO format
        if (value) {
            value = DateTime.fromFormat(value, 'dd/MM/yyyy').toISODate();
        }

        this.$emit('from-date-changed', value);
        this.currentPage = this.page;
    }
    @Watch('currentTo')
    public currentToDateChanged(value: string | null): void {
        // NOTE(Dan): The date for the control is formatted in dd/MM/yyyy,
        //            this needs to be converted to an ISO format
        if (value) {
            value = DateTime.fromFormat(value, 'dd/MM/yyyy').toISODate();
        }

        this.$emit('to-date-changed', value);
        this.currentPage = this.page;
    }
}
